"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelPerfectHitArea = void 0;
var MathUtils = require("../Utils/MathUtils");
/**
 * Pixel perfect hit area
 */
var PixelPerfectHitArea = /** @class */ (function () {
    function PixelPerfectHitArea(pRenderer, pTarget, pTheshhold) {
        if (pTheshhold === void 0) { pTheshhold = 0; }
        this._target = pTarget;
        this._norm = new PIXI.Point();
        this._pixel = new PIXI.Point();
        var data = pRenderer.plugins.extract.pixels(pTarget);
        var widthOffset = 0;
        var heightOffset = 0;
        // Apply offset to measurements to account for decimal values when using retina assets
        if (pTarget.texture.width % 1 !== 0) {
            widthOffset = -0.5;
        }
        if (pTarget.texture.height % 1 !== 0) {
            heightOffset = -0.5;
        }
        this._map = new Array();
        for (var x = 0; x < pTarget.texture.width + widthOffset; ++x) {
            this._map.push(new Array());
            for (var y = 0; y < pTarget.texture.height + heightOffset; ++y) {
                this._map[x][y] = data[(y * (pTarget.texture.width + widthOffset) + x) * 4 + 3] > pTheshhold;
            }
        }
    }
    Object.defineProperty(PixelPerfectHitArea.prototype, "width", {
        /**
         * Gets width
         */
        get: function () {
            return this._map.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PixelPerfectHitArea.prototype, "scaledWidth", {
        /**
         * Gets scaled width
         */
        get: function () {
            return this.width * this._target.scale.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PixelPerfectHitArea.prototype, "height", {
        /**
         * Gets height
         */
        get: function () {
            return this._map[0].length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PixelPerfectHitArea.prototype, "scaledHeight", {
        /**
         * Gets scaled height
         */
        get: function () {
            return this.height * this._target.scale.y;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Gets hit area at pixel
     * @param pX
     * @param pY
     * @returns boolean
     */
    PixelPerfectHitArea.prototype.getHitAreaAtPixel = function (pX, pY) {
        return this._map[pX][pY];
    };
    /**
     * Contains pixel perfect hit area
     * @param pX
     * @param pY
     * @returns boolean
     */
    PixelPerfectHitArea.prototype.contains = function (pX, pY) {
        this._norm.x = (pX + this.width * this._target.anchor.x) / this.width;
        this._norm.y = (pY + this.height * this._target.anchor.y) / this.height;
        // If we are within the bounds of the texture
        if (this._norm.x >= 0 && this._norm.x <= 1 && this._norm.y >= 0 && this._norm.y <= 1) {
            this._pixel.x = Math.floor(MathUtils.clamp(this._norm.x * this._map.length, 0, this._map.length - 1));
            this._pixel.y = Math.floor(MathUtils.clamp(this._norm.y * this._map[0].length, 0, this._map[0].length - 1));
            return this._map[this._pixel.x][this._pixel.y];
        }
        else {
            return false;
        }
    };
    return PixelPerfectHitArea;
}());
exports.PixelPerfectHitArea = PixelPerfectHitArea;
//# sourceMappingURL=PixelPerfectHitArea.js.map